(function ($, Drupal) {
  'use strict';

  $(document).ready(function () {
    // ---- create iframe for Youtube Video if click Thumbnail ----
    $(document).on('click touche', '.player', function (e) {
      var _this = $(this);
      var videoTrigger = _this.find('.video_trigger');
      var yt_playButton = _this.find('.yt_playButton');
      var bgImage = _this.find('.bg-image');
      if (readCookie('klaro')) {
        var klaro = JSON.parse(readCookie('klaro'));
        if (klaro && klaro.externe_dienste) {
          var videoId = _this.attr('data-ytv');
          var videoControls = _this.attr('data-controls');
          if ($(e.target).hasClass('player') || $(e.target).hasClass('yt_playButton') || $(e.target).hasClass('bg-image')) {
            playVideo(_this, videoId, videoControls);
          }
        } else {
          videoTrigger.show();
          yt_playButton.hide()
          bgImage.addClass('blur-stuff')
        }
      } else {
        videoTrigger.show();
        yt_playButton.hide()
        bgImage.addClass('blur-stuff')
      }
    });

    $(document).on('click touche', '.trigger_button', function (e) {
      var _this = $(this);
      var player = _this.closest('.player');
      var videoId = player.attr('data-ytv');
      var videoControls = player.attr('data-controls');
      var videoTrigger = _this.closest('.video_trigger');
      videoTrigger.fadeOut();
      updateCookie('klaro', 'externe_dienste');
      playVideo(player, videoId, videoControls);
    });

    function playVideo(el, videoId, videoControls) {
      el.append(
        '<iframe' +
        ' src="https://www.youtube-nocookie.com/embed/' + videoId + '?enablejsapi=1&rel=0&amp;controls=' + videoControls + '&amp;showinfo=1&amp;ytp-pause-overlay=0&amp;autoplay=1"' +
        ' frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
    }

    // ------

  });//  document.ready

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  function updateCookie(name, app) {
    var thatCookie = readCookie(name);
    if (thatCookie) {
      thatCookie = JSON.parse(thatCookie);
      thatCookie[app] = true
      createCookie(name, JSON.stringify(thatCookie), 365);
    }
  }


})(jQuery, Drupal);
